// removed by extract-text-webpack-plugin
module.exports = {"root":"_3GQ5i"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/Events/elements/EventList.sass
// module id = ./src/modules/Events/elements/EventList.sass
// module chunks = 6